module.exports = __webpack_public_path__ + "static/img/decorate.257cd26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/decorate.png
// module id = QiyR
// module chunks = 0